export class AuthToken {
  private type: string;
  public accessToken: string;

  constructor(type: string, accessToken: string) {
    this.type = type;
    this.accessToken = accessToken;
  }
}

export default AuthToken;
